import React from 'react'
import MenuGuideButton from '../components/MenuGuideButton'
import CustomerMemoTemplateManager from '../components/CustomerMemoTemplateManager'

export default function CustomerMemoTemplatesPage() {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 p-4 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-bold text-slate-900">고객메모 템플릿</h1>
          <MenuGuideButton slug="template-management" title="템플릿관리 가이드" />
        </div>
      </div>
      <CustomerMemoTemplateManager open variant="page" showClose={false} />
    </div>
  )
}